var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingComponentPage',{attrs:{"title":"休日カレンダー","summary":"法定休日、毎週の会社休日、日付ごとの休日を設定します。"}},[_c('HolidayCalendarSettings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }